import React from 'react';

interface BlobLoaderProps {
  size?: number;
  color?: string;
}

export const BlobLoader: React.FC<BlobLoaderProps> = ({ size = 110, color = '#5c1011' }) => {
  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: size,
        filter: 'url(#gooey)',
      }}
    >
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <filter id="gooey">
            <feGaussianBlur in="SourceGraphic" stdDeviation="6" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -10"
              result="g"
            />
            <feBlend in="SourceGraphic" in2="g" />
          </filter>
        </defs>
      </svg>
      {[0, 1, 2, 3].map((i) => (
        <span
          key={i}
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            width: size * 0.4,
            height: size * 0.4,
            marginLeft: -size * 0.2,
            marginTop: -size * 0.2,
            background: color,
            borderRadius: '50%',
            animation: `blobOrbit 2.4s ${i * 0.18}s cubic-bezier(.6,0,.4,1) infinite`,
          }}
        />
      ))}
    </div>
  );
};

export default BlobLoader;
